import React from 'react';
import PropTypes from 'prop-types';
import './ScrollBar.scss';

const ScrollBar = ({ trackRef, thumbRef, className }) => (
	<div
		className={`card-scroll-bar${className ? ` ${className}` : ''}`}
		ref={trackRef}
	>
		<div
			className="card-scroll-bar-thumb"
			ref={thumbRef}
		/>
	</div>
);

ScrollBar.propTypes = {
	trackRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.object }),
	]).isRequired,
	thumbRef: PropTypes.oneOfType([
		PropTypes.func,
		PropTypes.shape({ current: PropTypes.object }),
	]).isRequired,
	className: PropTypes.string,
};

ScrollBar.defaultProps = {
	trackRef: { current: null },
	thumbRef: { current: null },
	className: '',
};

export default ScrollBar;
